import { FiltroArrendamento } from './../models/arrendamento/filtro-arrendamento.model';
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {TipoFiltro} from '../models/arrendamento/tipo-filtro.enum';
import {Observable, throwError} from 'rxjs';
import {URL_HELP_API} from 'environments/environment';
import {ResponseBase} from '../interfaces/response-base';
import {ContratoArrendamento} from '../models/arrendamento/contrato-arrendamento.model';
import { catchError, take } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ContratoArrendamentoService {

    constructor(private httpClient: HttpClient) {}

    listarContratos(filtro: FiltroArrendamento): Observable<ResponseBase<ContratoArrendamento[]>> {
        const httpParams = new HttpParams()
            .set('tipoFiltro', filtro.tipoFiltro)
            .set('valorPesquisa', filtro.valorPesquisa);

        return this.httpClient.get<ResponseBase<ContratoArrendamento[]>>(URL_HELP_API.ARRENDAMENTO.LISTAR, {params: httpParams});
    }

    criarContrato(contratoArrendamento: ContratoArrendamento): Observable<any> {
        return this.httpClient.post<Observable<any>>(URL_HELP_API.ARRENDAMENTO.CRIAR, contratoArrendamento);
    }

    atualizarContrato(codigoPedido: string, contratoArrendamento: ContratoArrendamento): Observable<any> {
        return this.httpClient.put<Observable<any>>(`${URL_HELP_API.ARRENDAMENTO.ATUALIZAR}/${codigoPedido}` , contratoArrendamento);
    }

    cancelarContrato(codigoPedido: string): Observable<any> {
        return this.httpClient.patch<Observable<any>>(`${URL_HELP_API.ARRENDAMENTO.BASE}/${codigoPedido}/cancelar` , null);
    }

    finalizarContrato(codigoPedido: string): Observable<any> {
        return this.httpClient.patch<Observable<any>>(`${URL_HELP_API.ARRENDAMENTO.BASE}/${codigoPedido}/finalizar`, null)
            .pipe(take(1))
            .pipe(catchError(this.handleError));
    }

    getContratoPorPedidoId(codigoPedido: string): Observable<ContratoArrendamento> {
        return this.httpClient.get<ContratoArrendamento>(`${URL_HELP_API.ARRENDAMENTO.BASE}/pedido/${codigoPedido}`);
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}
